import React, { ReactNode } from "react";

import { Box, SxProps } from "@mui/material";
import { Theme } from "@mui/material/styles";

interface IgTabPanelProps {
  children?: ReactNode;
  index: number;
  value: number;
  sx?: SxProps<Theme>;
}

/**
 * @see HTMLDivElement
 * @see Box
 */
export const IgTabPanel = (props: IgTabPanelProps) => {
  const { children, value, index, sx, ...other } = props;

  return (
    <div
      hidden={value !== index}
      id={`ig-tab-panel-${index}`}
      aria-labelledby={`ig-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={sx}>
          <>{children}</>
        </Box>
      )}
    </div>
  );
};
